import { render } from "./segmented-control.vue?vue&type=template&id=3b8793a6"
import script from "./segmented-control.vue?vue&type=script&lang=js"
export * from "./segmented-control.vue?vue&type=script&lang=js"

import "./segmented-control.vue?vue&type=style&index=0&id=3b8793a6&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__